// extracted by mini-css-extract-plugin
export default {"container":"_14sE","title":"_1Pwz"};